import { createColumnHelper } from '@tanstack/react-table';
import { useNavigate, useParams } from 'react-router-dom';
import { OrderTable } from '@services/product/order/order.types';

export const useDetailsPurchasesVM = () => {
    const { id } = useParams();
    const columnHelper = createColumnHelper<OrderTable>();
    const navigate = useNavigate();
    
    return {
        id,
        navigate,
        columnHelper
    };
};
